<div class="popup-overlay popup-backgound active"></div>
<section #overlayContainer tabindex="-1" class="biometric-consent-overlay popup-backgound w-100 h-100 fixed"
  id="biometricConsentOverlay" role="dialog" aria-modal="true" aria-labelledby="biometricConsentHeading"
  (keyup.escape)="onClose()">
  <div class="biometric-consent-overlay-wrapper d-flex flex-column background-white round-top16 round-0-768">
    <button class="mobile-close d-flex d-md-none" (click)="onClose()" (keyup.enter)="onClose()" aria-label="Close">
      <img class="pointer" src="assets/images/close-white.svg" alt="close-icon" width="18" height="18" />
    </button>
    <div
      class="biometric-consent-overlay__header d-none d-md-flex justify-content-between align-items-center px-24 py-16 px-32-768 py-24-768 border-bottom-rgbaGrey500">
      <h3 id="biometricConsentHeading" class="heading4 heading3-768 font-semibold text-black">Review biometric consent</h3>
      <button class="closeButton d-flex" (click)="onClose()" (keyup.enter)="onClose()" aria-label="Close">
        <img class="pointer" src="assets/images/close.svg" alt="close-icon" width="24" height="24" />
      </button>
    </div>

    <div class="biometric-consent-overlay__body d-flex flex-column custom-scroll">
      <div class="biometric-consent-intro d-flex flex-column gap-16 gap-16-768 px-32-768 pt-32 p-24">
        <img src="assets/icons/biometric-face-scan.svg" alt="biometric icon" class="biometric-icon" width="56"
          height="56" />
        <div class="d-flex flex-column gap-6 gap-6-768">
          <h2 class="heading1 heading2-768 font-bold text-black">A safer test day with biometrics</h2>
          <p class="paragraph-large paragraph-large-768 txt-charcoalGrey500 font-open">
            To help make your IELTS check-in quick and secure, we use facial scans for identity verification. This reduces
            delays and ensures accurate identification. Please review the terms and conditions before continuing.
          </p>
        </div>
      </div>

      <div class="biometric-consent-terms background-white px-32-768 px-24 d-flex flex-column gap-24-768 gap-8">
        <h4 class="heading5 heading5-768 font-semibold text-black">Identity Document Verification (IDV) System Testing:</h4>
        <ol class="d-flex flex-column gap-12 gap-12-768">
          <li class="font-16 lh-28 txt-charcoalGrey500 font-open">
            An image of you and your identity document will be captured to compare and identify any inconsistencies
            (“Biometric Verification”). This assessment process will use automated facial recognition technology to
            enhance and streamline the identity verification process. Biometric Verification data collected may also be
            used to test the IDV system performance from time to time. Biometric Verification data will be encrypted and
            stored in secure servers and only used for the purposes outlined herein. The data will be retained for a
            period of 3 years from the date it is captured then securely deleted. Only authorized personnel will have
            access to your data.
          </li>
          <li class="font-16 lh-28 txt-charcoalGrey500 font-open">
            We may disclose Biometric Verification data we collect to the IELTS support teams, or IELTS Partners for
            purposes consistent with the IELTS Privacy Policy and may disclose/receive the assessment or Biometric
            Verification data to/from other third parties involved in supporting or providing Biometric Verification
            services for IELTS, based upon your given consent below, as well as when required by law. You can opt out
            from the biometric verification on the test day, by informing test day staff. Note that you will still be
            required to take a test day photo, however the automated assessment will not be performed but a manual
            assessment will still need to take place.
          </li>
        </ol>
      </div>

      <div class="biometric-consent-terms-box d-flex p-24 py-24-768 px-32-768">
        <label class="biometric-consent-check d-flex gap-12 gap-12-768 p-16 p-16-768 round-8 border-rgbaGrey500 pointer background-white"
          [class.checked]="consentGiven">
          <input type="checkbox" class="biometric-consent-check__input" [checked]="consentGiven"
            (change)="toggleConsent()" />
          <span class="paragraph-xs-small paragraph-small-768 txt-charcoalGrey500 font-open">
            I hereby consent to the collection and use of my Biometric Verification data (including my facial image and
            identity document) as described above. I understand that this data will only be used for the purposes as set
            out above and will not be otherwise be disclosed or used for any other purpose.
          </span>
        </label>
      </div>

    </div>

    <div
      class="biometric-consent-overlay__footer d-flex align-items-center justify-content-center py-16 px-24 py-20-768 px-32-768 background-white">
      <button
        class="confirm-btn background-red500 txt-white p-12 round-100 p-12-768 lh-24-0 font-semibold paragraph-Medium paragraph-Medium-768 lh-24-768 round-100-768 d-flex align-items-center justify-content-center w-100"
        [disabled]="!consentGiven" (click)="onConfirm()">Confirm</button>
    </div>
  </div>
</section>
